import React from 'react';
import { JbShort as JbShortLogo } from '@jbhi-fi/lanyard-ui/components/Icons';
import { Base, LoadingSkeletonProps } from '../../Base/Base';
import { PossiblyResponsiveValue, useResponsiveValue } from '../../../hooks/useResponsiveValue';
import { styles } from './ImageSkeleton.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

export type ImageSkeletonProps = {
  aspectRatio?: PossiblyResponsiveValue<number>;
  iconWidth?: PossiblyResponsiveValue<React.CSSProperties['width']>;
} & Omit<LoadingSkeletonProps, 'height'>;

export const ImageSkeleton = ({
  aspectRatio: aspectRatioProp = 1,
  iconWidth: iconWidthProp = 'min(50%, 100px)',
  shouldShimmer: shouldShimmerProp = true,
  shimmerColor = palette.primary.neutral,
  className,
  ...props
}: ImageSkeletonProps) => {
  const aspectRatio = useResponsiveValue(aspectRatioProp);
  const iconWidth = useResponsiveValue(iconWidthProp);
  const shouldShimmer = useResponsiveValue(shouldShimmerProp);

  return (
    <Base height="auto" className={classNames(styles.container, className)} shimmerColor={shimmerColor} {...props}>
      <div style={{ paddingBottom: `${(1 / aspectRatio) * 100}%`, width: '100%', height: 0 }}>
        <JbShortLogo className={styles.jbIcon({ shouldShimmer })} style={{ width: iconWidth }} />
      </div>
    </Base>
  );
};
